function Footer() {
    return (
        <footer className='footer animload'>
            <a className='footer__link' href='http://landerexit.github.io/me'>
                <h2 className='footer__author'>Автор сайта</h2>
                <p>landerexit@gmail.com</p>
            </a>
        </footer>
    );
}

export default Footer;